import { useState } from 'react';

const galleryItems = [
  {
    image: 'https://public.readdy.ai/ai/img_res/888e967229064ceadad9b31d7f1553d1.jpg',
    title: 'Tornitura CNC',
    category: 'Lavorazioni'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=industrial%20milling%20machine%20cutting%20steel%20component%20with%20precision%20tools%20in%20professional%20metalworking%20facility%20with%20organized%20workspace&width=800&height=600&seq=gallery2&orientation=landscape',
    title: 'Fresatura di Precisione',
    category: 'Lavorazioni'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=stacked%20steel%20beams%20and%20iron%20construction%20materials%20in%20organized%20warehouse%20with%20industrial%20storage%20system%20for%20building%20industry&width=800&height=600&seq=gallery3&orientation=landscape',
    title: 'Materiali Ferrosi',
    category: 'Commercio'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=welding%20sparks%20on%20metal%20structure%20construction%20with%20professional%20welder%20creating%20steel%20framework%20in%20industrial%20setting&width=800&height=600&seq=gallery4&orientation=landscape',
    title: 'Saldatura Strutture',
    category: 'Strutture'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=quality%20control%20inspection%20of%20metal%20parts%20with%20precision%20measuring%20tools%20and%20calipers%20in%20professional%20workshop%20environment&width=800&height=600&seq=gallery5&orientation=landscape',
    title: 'Controllo Qualità',
    category: 'Lavorazioni'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=completed%20metal%20structure%20framework%20for%20industrial%20building%20showing%20engineering%20excellence%20and%20professional%20construction%20work&width=800&height=600&seq=gallery6&orientation=landscape',
    title: 'Strutture Completate',
    category: 'Strutture'
  }
];

export default function Gallery() {
  const [filter, setFilter] = useState('Tutti');
  const categories = ['Tutti', 'Lavorazioni', 'Commercio', 'Strutture'];

  const filteredItems = filter === 'Tutti' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === filter);

  return (
    <section id="galleria" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Galleria Lavori
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto mb-8">
            Scopri alcuni dei nostri progetti e lavorazioni che testimoniano la qualità e la precisione del nostro lavoro
          </p>

          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                className={`px-6 py-2.5 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer ${
                  filter === category
                    ? 'bg-gradient-to-r from-slate-700 to-slate-900 text-white shadow-lg'
                    : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredItems.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-80">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-medium mb-2">
                  {item.category}
                </span>
                <h3 className="text-xl font-bold">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}